import Vue from "vue";
import { HTTP, HMD_BACKEND_API_URL } from "@/utils/http-common";
import axios from "axios";

export default {
  email_validation(key, parent) {
    HTTP.post("/account/registration/verify-email/", {
      key: key
    })
      .then(response => {
        // parent.$router.replace('/signin')
        parent.$data.result = response.data.detail;
        setTimeout(() => {
          parent.$router.replace("/signin");
        }, 3000);
      })
      .catch(error => {
        parent.$data.result = error.response.data.detail;
        // parent.$store.commit('push', {msg: 'Error ' + error, color: 'error'});
        parent.$store.commit("push", {
          msg: "Error " + error.response.data,
          color: "error"
        });
      });
  },
  resetPassword(email, parent) {
    return new Promise((resolve, reject) => {
      return HTTP.post("/account/password/reset/", { email: email })
        .then(response => {
          parent.$store.commit("push", {
            msg: "E-mail succesfully sent!",
            color: "success"
          });
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          parent.$store.commit("push", { msg: error, color: "error" });
          reject(error);
        });
    });
  },
  sendNewPassword(parent, password1, password2, uid, key) {
    HTTP.post("/account/password/reset/confirm/", {
      uid: uid,
      token: key,
      new_password1: password1,
      new_password2: password2
    })
      .then(response => {
        console.log(response);
        parent.$store.commit("push", {
          msg: response.data.detail,
          color: "success"
        });
        setTimeout(() => {
          window.location.href = response.data.redirect;
        }, 3000);
      })
      .catch(error => {
        console.log(error);
        parent.$store.commit("push", { msg: error, color: "error" });
      });
  },
  emailNotReceived(email, parent) {
    return new Promise((resolve, reject) => {
      return HTTP.post("/account/registration/resend-confirm-email/", {
        email: email
      })
        .then(response => {
          parent.$store.commit("push", {
            msg: "E-mail succesfully sent!",
            color: "success"
          });
          resolve(response);
        })
        .catch(error => {
          parent.$store.commit("push", {
            msg: _.join(error.response.data.error, "\n"),
            color: "error"
          });
          reject(error);
        });
    });
  },

  // Invitations
  invitationAcceptInvite(key) {
    return HTTP.get("/invitations/accept/" + key + "/");
  }
};
